import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { createReduxEnhancer } from '@sentry/react'

import apiServiceMiddleware from '@probatix/common/services/toolkit/api/apiService.middleware'

import loginMiddleware from '@probatix/common/middlewares/login.middleware'
import { activateQueryMiddleware } from '@probatix/common/middlewares/activate.middleware'
import { jwtQueryMiddleware } from '@probatix/common/middlewares/jwt.middleware'

import logoutMiddleware from '@probatix/common/middlewares/logout.middleware'

import { ENTRYPOINT, ENV } from '@probatix/myprobatix/config/app'

import generateDOBTokenApiMiddleware from '@probatix/common/services/RTKServices/generateDOBToken/index.middleware'
import activationApiMiddleWare from '@probatix/common/services/RTKServices/activation/index.middleware'
import availabilitiesApiMiddleware from '@probatix/common/services/RTKServices/availabilities/index.middleware'
import checkoutApiMiddleware from '@probatix/common/services/RTKServices/checkoutSteps/index.middleware'
import patientsApiMiddleware from '@probatix/common/services/RTKServices/patients/index.middleware'
import productsApiMiddleware from '@probatix/common/services/RTKServices/products/index.middleware'
import patientEventsApiMiddleware from '@probatix/common/services/RTKServices/patientEvents/index.middleware'
import specimensApiMiddleware from '@probatix/common/services/RTKServices/specimens/index.middleware'
import testKitsApiMiddleware from '@probatix/common/services/RTKServices/testKits/index.middleware'
import graphQLApiMiddleWare from '@probatix/common/services/RTKServices/graphQL/index.middleware'
import locationsApiMiddleware from '@probatix/common/services/RTKServices/locations/index.middleware'
import testResultApiMiddleware from '@probatix/common/services/RTKServices/testResult/index.middleware'
import teleClinicMiddleware from '@probatix/common/services/RTKServices/partners/index.middleware'
import userObservationsApiMiddleware from '@probatix/common/services/RTKServices/userObservations/index.middleware'
import testsFormPersistMiddleware from './middlewares/testsFormPersist.middleware'

import reducers from './reducers'

const appReducer = reducers

const rootReducer = (state, action) => appReducer(state, action)

export const middlewares = [
  apiServiceMiddleware({
    apiPrefix: 'local' !== ENV ? 'api' : '',
    entrypoint: ENTRYPOINT,
    withCredentials: true,
    withRelativeUrl: 'local' !== ENV,
  }),
  loginMiddleware(),
  activateQueryMiddleware,
  jwtQueryMiddleware,
  logoutMiddleware(),
  availabilitiesApiMiddleware,
  generateDOBTokenApiMiddleware,
  checkoutApiMiddleware,
  patientsApiMiddleware,
  patientEventsApiMiddleware,
  specimensApiMiddleware,
  testKitsApiMiddleware,
  graphQLApiMiddleWare,
  productsApiMiddleware,
  locationsApiMiddleware,
  testResultApiMiddleware,
  teleClinicMiddleware,
  userObservationsApiMiddleware,
  activationApiMiddleWare,
  testsFormPersistMiddleware,
]

const sentryReduxEnhancer = createReduxEnhancer({})

const store = configureStore({
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers.concat(sentryReduxEnhancer),
  middleware: (getDefaultMiddleware) => (
    getDefaultMiddleware({ serializableCheck: false }).concat(middlewares)
  ),
  reducer: rootReducer,
})

setupListeners(store.dispatch)

export default store
